import { useQuery } from 'hooks'
import { useEffect, useMemo, useState } from 'react'
import { fetchOrdersLogs } from 'utils/api/logsApi'
import { calculateOffset } from 'utils/helpers/pagination'
import { getColumns } from './utils'
import DataTable from 'components/common/dataTable'
import { DataTablePagination } from 'components/common'
import { useLocation } from 'react-router-dom'

const OrderLogTable = () => {
  const [logResponse, setLogResponse] = useState<any>({})
  const [page, setPage] = useState<number>(0)

  const { getQuery } = useQuery()
  const { search } = useLocation()

  const columns = useMemo(() => getColumns(page), [page])

  const getLogs = async () => {
    try {
      const { data } = await fetchOrdersLogs({
        limit: getQuery('limit') || 10,
        page: getQuery('page') || 1,
      })
      setPage(calculateOffset(data))
      setLogResponse(data)
    } catch (error) {
      setLogResponse({ docs: [] })
    }
  }

  useEffect(() => {
    getLogs()
  }, [search])

  return (
    <>
      <h2 className="title">Orders Logs</h2>
      <DataTable columns={columns} rows={logResponse?.docs} identifier="_id" />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={logResponse?.page}
        totalPages={logResponse?.totalPages}
        hasNextPage={logResponse?.hasNextPage}
        hasPrevPage={logResponse?.hasPrevPage}
        limit={logResponse?.limit}
        nextPage={logResponse?.nextPage}
        prevPage={logResponse?.prevPage}
      />
    </>
  )
}
export default OrderLogTable
